export * from './useAutomaticPlacement';
export type { PlacementOptions } from './useAutomaticPlacement.types';
